import type {SafeHTMLString} from '@github-ui/safe-html'
import type {AllowedNonCommentReviewType} from './page-data/payloads/toolbar'

export interface PullRequest {
  author: {
    login: string
    displayName?: string | null
    avatarUrl?: string | null
    isAgent?: boolean
    /** App slug used to build agent links/hovercards (e.g. `copilot-swe-agent`), distinct from the display login. */
    slug?: string | null
  }
  attributedUser?: {
    login: string
    displayName?: string | null
    avatarUrl?: string | null
  } | null
  id: number
  aliveChannel: string
  baseBranch: string
  pathName: string
  commitsCount: number
  headBranch: string
  headRepositoryName?: string
  headRepositoryOwnerLogin?: string
  headSha: string
  isInAdvisoryRepo: boolean
  mergedBy?: string
  mergedByAvatarUrl?: string | null
  mergedByName?: string
  closedTime?: string
  createdTime?: string
  mergedTime?: string
  number: number
  state: PullRequestState
  title: string
  titleHtml: SafeHTMLString
  url: string
  globalRelayId: string
  viewerAllowedNonCommentReviewTypes: AllowedNonCommentReviewType[]
}

export const PullRequestState = {
  Open: 'OPEN',
  Closed: 'CLOSED',
  Merged: 'MERGED',
  Queued: 'QUEUED',
  Draft: 'DRAFT',
  Archived: 'ARCHIVED',
} as const

export const STATE_LABEL_DATA = {
  [PullRequestState.Open]: {
    description: 'Open',
    status: 'pullOpened',
  },
  [PullRequestState.Closed]: {
    description: 'Closed',
    status: 'pullClosed',
  },
  [PullRequestState.Queued]: {
    description: 'Queued',
    status: 'pullQueued',
  },
  [PullRequestState.Merged]: {
    description: 'Merged',
    status: 'pullMerged',
  },
  [PullRequestState.Draft]: {
    description: 'Draft',
    status: 'draft',
  },
  [PullRequestState.Archived]: {
    description: 'Archived',
    status: 'archived',
  },
} as const

export type PullRequestState = (typeof PullRequestState)[keyof typeof PullRequestState]
